export const colors = {
  white: "#FFFFFF",
  black: "#000000",
  primary: "#CA797A",
  secondary: "#5fa2c7",
  bgLight: "#F8F7FF",
  bgDark: "#87CCFB",
}
